/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, node, number, func } from 'prop-types'
import { jsx, Label, Input, Flex } from 'theme-ui'
import { useField } from 'formik'
import './formInputs.css'
import FlatButton from '../Buttons/FlatButton'
import { ErrorMessage, HelperText } from './Common'

// Custom field input that adds Formik functionality to theme-ui's Textinput, and adds our styling, and icon option.
const TextInput = ({
  label,
  removeMargin,
  inputWidth = '100%',
  errorMessage,
  maxLength,
  ...props
}) => {
  const [field, meta] = useField(props)
  return (
    <Flex sx={{ mb: removeMargin ? 0 : 5, flexDirection: 'column' }}>
      <Label htmlFor={props.name}>{label}</Label>
      <HelperText>{props.helperText}</HelperText>
      <Flex>
        <Input
          {...field}
          {...props}
          sx={{
            mb: removeMargin ? 0 : 2,
            width: inputWidth,
            bg:
              meta.touched && meta.error
                ? 'inputError'
                : !meta.error && meta.value
                ? 'inputSuccess'
                : 'inputBackground',
          }}
          maxLength={maxLength}
        />
        {props.buttonIcon ? (
          <FlatButton
            sx={{
              display: 'flex',
              mt: 3,
              ml: 3,
              flexShrink: 0,
            }}
            buttonStyle="tertiary"
            color="forest"
            size="large"
            leftIcon={props.buttonIcon}
            disabled={props.buttonDisabled}
            onClick={props.handleIconClick}
            onKeyDown={props.handleIconClick}
            type="button"
          >
            {props.buttonText}
          </FlatButton>
        ) : null}
      </Flex>
      {meta.touched && (meta.error || errorMessage) ? (
        <ErrorMessage>{meta.error ? meta.error : errorMessage}</ErrorMessage>
      ) : null}
    </Flex>
  )
}

TextInput.propTypes = {
  buttonDisabled: bool,
  buttonIcon: node,
  buttonText: string,
  handleIconClick: func,
  helperText: string,
  label: string.isRequired,
  maxLength: number,
  name: string.isRequired,
  removeMargin: bool,
  inputWidth: string,
  errorMessage: string,
}

export default TextInput
